export const skills = [
    { name: 'Python / Django', level: 70 },
    { name: 'JavaScript / React / React Native', level: 75 },
    { name: 'AI (ML / DL)', level: 55 },
    { name: 'CyberSécurité', level: 60 },

    { name: 'Git / GitHub', level: 80 },
    { name: 'Docker', level: 45 },
    { name: 'Connaissance moyenne en Administration Linux', level: 50 },
    { name: 'Méthodes Agiles', level: 65 },
    { name: 'API REST', level: 80 },
];

export const experiences = [
    {
        poste: 'Développeur Backend (Django) - Stage Académique',
        entreprise: 'Magis Fintech Solution',
        duree: 'sept 2024 - nov 2024',
        lieu: 'Mwaro, Burundi',
        description:
            "Apprentissage des bases de l'architecture backend et initiation aux flux de travail de l'entreprise sur Django.",
    },
    {
        poste: 'Développeur backend (Django)',
        entreprise: 'Magis Fintech Solution',
        duree: 'nov 2024 - mars 2025',
        lieu: 'Mwaro, Burundi',
        description:
            "J'ai développé et maintenu des applications web avec Django. Mon travail s'est concentré sur les API, la gestion de bases de données et la mise en place de systèmes back-end rapides et sécurisés.",
    },
    {
        poste: 'Formateur HTML/CSS & JavaScript',
        entreprise: 'Omega Technology',
        duree: 'avr 2025 - dec 2025',
        lieu: 'Bujumbura, Burundi',
        description:
            "J'ai formé des étudiants en HTML, CSS et JavaScript, les aidant à développer des projets concrets et à maîtriser les bases du développement web.",
    },
    {
        poste: 'Encadreur Python & Django',
        entreprise: 'SOFT AVOLIK',
        duree: 'sept 2025 - oct 2025',
        lieu: 'Bujumbura, Burundi',
        description:
            "Supervision technique et encadrement d'étudiants en stage académique sur des projets pratiques utilisant Python et le framework Django.",
    },
    {
        poste: 'IA & Sécurité',
        entreprise: 'Projets personnels et recherches',
        duree: '2026 - Présent',
        lieu: 'Bujumbura, Burundi',
        description:
            "Exploration et développement de projets liés à l'IA et la cybersécurité.",
    },
];

export const education = [
    {
        diplome: 'Licence en Génie & Gestion des Télécommunications (Validée)',
        ecole: "Université Espoir d'Afrique",
        duree: '2022 - 2025',
        lieu: 'Bujumbura, Burundi',
    },
    {
        diplome: 'Baccalauréat',
        ecole: 'Institut La charité',
        duree: 'Obtenu',
        lieu: 'RD Congo, Sud-Kivu, Baraka',
    },
];

export const languages = [
    { name: 'Français', level: 'Courant' },
    { name: 'Anglais', level: 'Intermédiaire' },
];

export const atouts = [
    'Travail en équipe',
    "Bonne capacité d'adaptation",
    'Curiosité technologique',
    "Esprit d'analyse",
];

export const interests = [
    { name: 'Football', description: "J'aime le football" },
    { name: 'Musique', description: "J'aime la musique" },
];
